import { Box, Typography, Skeleton } from '@mui/material'
import React from 'react'
import { useStyles } from '../../styles'
import { formatAmount } from '../utils'

const PriceBox = ({ isLoading, label, price, currency, className }) => {
  const classes = useStyles()
  const formattedLabel = !isLoading ? label : <Skeleton width={50} />
  const formattedPrice = !isLoading ? formatAmount(currency, price) : <Skeleton width={50} />

  return (
    <Box className={classes.priceBox}>
      <Typography className={className}>{formattedLabel}</Typography>
      <Typography className={className}>{formattedPrice}</Typography>
    </Box>
  )
}

export default PriceBox
